import { DependentEventFilter } from '@fullstory/proto/fs/api/segment';
import { UnnamedOverlay } from '@fullstory/proto/fs/services/dx-objects';
import { OverlayOverrideMessage, OverlayOverrideMessageProps } from './OverlayOverrideMessage';
import { createContext } from 'react';
import { isEqual } from 'lodash';

export interface OverlayOverrideContextProps {
  hasOverlay: boolean;
  overlayOverrideMessage: React.ComponentType<OverlayOverrideMessageProps>;
  isDependentEventFilterOverridden: (dep: DependentEventFilter) => boolean;
}

export const OverlayOverrideContext = createContext<OverlayOverrideContextProps>({
  hasOverlay: false,
  overlayOverrideMessage: OverlayOverrideMessage,
  isDependentEventFilterOverridden: () => false,
});

export const useOverlayOverrideContext = (
  overlay: UnnamedOverlay | null | undefined,
  overlayOverrideMessage: React.ComponentType<OverlayOverrideMessageProps>,
): OverlayOverrideContextProps => ({
  hasOverlay: !!overlay,
  overlayOverrideMessage,
  isDependentEventFilterOverridden: dep => {
    if (!overlay) return false;
    return overlay.deps.findIndex(d => isEqual(d, dep)) >= 0;
  },
});
